const books = {
    name: "Manuais de Debate",
    content: [
        {
            link:"https://drive.google.com/file/d/1hRD5dTkda9GjPFusJn-jQxsFPPaCZJpl/view?usp=sharing",
            text:"Debater Handbook"
        },
        {
            link:"https://drive.google.com/file/d/1l7i3Jttb6oIqeU91rCUOcRX5vxarSTzs/view?usp=sharing",
            text:"Manual de Debates SdDUFC"
        },
        {
            link:"https://drive.google.com/file/d/1rg9gNHM9-oFDmRPToiX0f5vlVIZP6gXz/view?usp=sharing",
            text:"WUDC Judging Manual"
        },
        {
            link:"https://drive.google.com/file/d/1HinB_GhRJK7w1l9cg9IQ5iOzQ3jnPCja/view?usp=sharing",
            text:"Pros and Cons"
        },
        {
            link:"https://drive.google.com/file/d/11Elw0zkFcnm9T-COF2kryJFzKMgX99wE/view?usp=sharing",
            text:"Training Guide for University Debating"
        },
        {
        	link:"https://drive.google.com/file/d/1kDlJ1v4h-qPtIU1u_oka-jH5za0Wcuyq/view?usp=sharing",
        	text:"The Practical Guide to Debating"
        },
    ]
}

const trainingPT = {
    name: "Formações - PT",
    content: [
        {
            link:"https://www.youtube.com/watch?v=qn6B0_5PyRM",
            text:"Impactos"
        },
        {
            link:"https://www.youtube.com/watch?v=POZGeXsdQiE",
            text:"Geopolítica"
        },
        {
            link:"https://www.youtube.com/watch?v=rariyP7Yzn4",
            text:"Adjudicação"
        }
    ]
}

const trainingEN = {
    name: "Formações - EN",
    content: [
        {
            link:"https://www.youtube.com/watch?v=qHX-PZQe2QQ",
            text:"Burdens of Proof"
        },
        {
            link:"https://www.youtube.com/watch?v=lIgxr1GzXDU",
            text:"Stop sucking at principles"
        },
        {
            link:"https://www.youtube.com/watch?v=acXxhooa73c",
            text:"Whip"
        },
        {
            link:"https://www.youtube.com/watch?v=7iq247GGA_8",
            text:"How to nail arguments about narratives, messages and symbols"
        },
        {
            link:"https://www.youtube.com/watch?v=IhbBUr6D6EY",
            text:"Case strategy and construction"
        },
        {
            link:"https://www.youtube.com/channel/UC1Cdkqn2WrTxLaLfmo_YxUA",
            text:"European debate training platform"
        },
        {
            link:"https://www.youtube.com/channel/UCbx6dh3PTCY3q4TqIaXHfpQ",
            text:"Astana debate union"
        },
        {
            link:"https://www.youtube.com/c/ManchesterDebatingUnion",
            text:"Manchester debating union"
        },
    ]
}

const written = {
	name: "Formações - Escritas",
	content: [
		{
		    link: "https://docs.google.com/document/d/1ZnLYmmvd_wom_u0EZk7JPXBBVtLsgACmA10oy7v68C8/",
		    text: "Motion Setting and Evaluating"
		},
        {
            link:"https://drive.google.com/file/d/1HQLuMe0Mo1_PiEr3ZONaEyPQ8bOadrr1/view?usp=sharing",
            text:"How to be a good and useful wing"
        },
        {
            link:"https://drive.google.com/file/d/1GpILvodIuywXAUy6n4bwl9D5_YSYnBfe/view?usp=sharing",
            text:"Como Ganhar em BP?"
        },
        {
            link:"https://drive.google.com/file/d/1pmyoOX02E3OSbztR3sCf8zhwmJOHOrj-/view?usp=sharing",
            text:"SDUL - 101"
        },
        //{
        //	link:"https://drive.google.com/file/d/1xyhkJa78me748M9SbsTIjWU3GB7_vuKk/view?usp=sharing",
        //	text:"Formações CNADU"
        //},
        {
        	link:"https://drive.google.com/file/d/1RtOe92PmEldvuac22ojdeJcnNDOXx__N/view?usp=sharing",
        	text:"How to debate International Relations"
        },
	]
}

const debatesPT = {
    name: "Debates - PT",
    content: [
        {
            link:"https://www.youtube.com/watch?v=ipwYKM4gEPs",
            text:"TIIL - Final de Iniciados"
        },
        {
            link:"https://www.youtube.com/watch?v=hDU0hambm9I",
            text:"Open Digital de Coimbra - Semi 1"
        },
        {
            link:"https://www.youtube.com/watch?v=xnTPtXiYFms",
            text:"Open Digital de Coimbra - Semi 2"
        },
        {
            link:"https://www.youtube.com/watch?v=yeMZ8f04TuM",
            text:"Open Digital de Coimbra - Final"
        },
        {
            link:"https://www.youtube.com/watch?v=TEcFWbWa_pw",
            text:"Rio Open - Semi 1"
        },
        {
            link:"https://www.youtube.com/watch?v=WzhPlJuRyTc",
            text:"Rio Open - Semi 2"
        },
        {
            link:"https://www.youtube.com/watch?v=yZfUxdbaBJs",
            text:"Rio Open - Final"
        }
    ]
}

const debatesEN = {
    name: "Debates - EN",
    content: [
        {
            link:"https://www.youtube.com/watch?v=tngaDNSlCpU",
            text:"THBT the world's poor would be justified in pursuing complete Marxist revolution."
        },
        {
            link:"https://www.youtube.com/watch?v=RMEEZGoUmvI",
            text:"THS Iran's extension of the Sharia principle of 'an eye for an eye' to the victims of acid attacks."
        },
        {
            link:"https://www.youtube.com/watch?v=3WX-4i9FqvE",
            text:"THBT governments should abandon the strategy of 'decapitation' in fighting terrorism."
        },
        {
            link:"https://www.youtube.com/watch?v=gyg5B2hMb5E",
            text:"THW choose the job they are passionate about."
        }
    ]
}

const websites = {
    name: "Websites e Artigos",
    content: [
        {
            link:"https://ehpriori.com/home/becoming-super-saiyan",
            text:"Becoming Super Saiyan"
        },
        {
            link:"https://ehpriori.com/",
            text:"Eh Priori"
        },
        {
            link:"http://hellomotions.com/",
            text:"Hello motions!"
        },
    ]
}

export const resources = [
    books,
    trainingPT,
    trainingEN,
    written,
    debatesPT,
    debatesEN,
    websites,
]